import { ActivatedUser } from "./activated-user";
import { DeactivatedUser } from "./deactivated-user";

type UserBoxProps = {
  id: string;
  type: string;
  avatar: string | null;
  is_active: boolean;
  job_title: string;
  last_name: string;
  first_name: string;
  company: {
    name: string;
  };
};

export function UserBox({ user }: { user: UserBoxProps }) {
  if (user.is_active) {
    return <ActivatedUser user={user} />;
  }

  return <DeactivatedUser type={user.type} companyName={user.company.name} />;
}
